<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <circle cx="12" cy="8" r="4"/>
    <path d="M3 21 C3 16 7 13 12 13 C17 13 21 16 21 21"/>
  </svg>
</template>
